import { FC, useCallback, useEffect, useState } from 'react'
import css from './index.module.less'
import { Card, SearchBar } from 'antd-mobile'
import { Link } from 'react-router-dom'
import { RightOutline, UserCircleOutline } from 'antd-mobile-icons'
import { withTranslation } from 'react-i18next'
import { useStoreDispatch, useStoreState } from '@/store'
import { useNav } from '@/hooks/useNav'
import { useSelectRole } from '@/hooks/useSelectRole'
import { PageLoading } from '@/components/PageLoading'
import { Notice } from '@/pages/home/Home/components/Notice'
import { SelfService } from '@/pages/home/Home/components/SelfService'
import { CenterSelf } from '@/pages/home/Home/components/CenterSelf'
import { unLoginVerify } from '@/pages/user/UnLogin'
import { getUrlParam } from '@/utils'
import { getMsgState } from '@/api/user'
import { QuestionList } from '@/pages/home/QuestionList'
import BannerSwiper from '@/pages/home/Home/components/BannerSwiper'

var _hmt = _hmt || [];

const Home: FC<any> = props => {
  const { t } = props;
  const { nav, genLink } = useNav();
  const [getRoles] = useSelectRole();
  const { centerConfig, pageLoading, role, user }: any = useStoreState();
  const dispatch = useStoreDispatch();
  const [showRedDot, setShowRedDot] = useState(false);

  const toQuestionListPage = useCallback(() => nav('/question-list'), []);
  const getRedDot = useCallback(async () => {
    let res = await getMsgState({
      gameCode: role.gameCode
    });
    if (res.code === 0) {
      setShowRedDot(res.data?.unRead);
    }
  }, [])

  useEffect(() => {
    let sdk = getUrlParam('sdk');
    let userInfo = getUrlParam('userInfo') || getUrlParam('userinfo');
    let appId = getUrlParam('appId') || getUrlParam('appid');
    let ticket = getUrlParam('ticket');
    if (userInfo || ticket) {
      unLoginVerify({
        sdk,
        userInfo,
        appId,
        ticket,
        type: ticket ? 6 : 4,
        callBack: (res) => {
          dispatch(res)
          getRoles()
        }
      })
    }

    // 处理URL携带的appId情况，和不携带情况的兼容处理
    if (appId) {
      // all为全部，则需要去掉
      if (appId === 'all') {
        localStorage.removeItem('csfeAppId');
      } else {
        localStorage.setItem('csfeAppId', `${appId}_${+new Date()}`);
      }
    } else {
      let getLocalStorage = localStorage.getItem('csfeAppId');
      let currentTimestamp = +new Date();
      let savedTimestamp = getLocalStorage ? +getLocalStorage.split('_')[1] : 0;
      let hoursPassed = (currentTimestamp - savedTimestamp) / (1000 * 60 * 60);
      // 检查是否大于24小时
      if (hoursPassed >= 24) {
        localStorage.removeItem('csfeAppId');
      }
    }
    // 需要加延迟，不然会立马触发
    setTimeout(() => {
      // 获取红点
      localStorage.getItem('token') && getRedDot()
    }, 800)
  }, [])

  if (pageLoading) return <PageLoading />

  return (
    <div className={`${css.Page} ${process.env.REACT_APP_IDN_ENV === 'hw' ? css.hw : ''} ${(process.env.REACT_APP_IDN_ENV === 'hw' && !centerConfig.banner) ? css.hwpt : ''}`}>
      {/* {location.href} */}
      <div className={css.PageHd}>
        <div className={css.ImgWrap}>
          <BannerSwiper 
            fallbackImage={centerConfig.banner}
            list={user.isLogin ? centerConfig.bannerVos : centerConfig?.bannerVos?.slice(0, 1)}
          />
        </div>
        <div className={css.ToolBar}>
          <SearchBar className={css.SearchBar} placeholder={t('common.search-placeholder')} onFocus={() => nav('/search')} />
          <Link className={`no-decoration ${css.BtnLogin} ${showRedDot ? css.redDot : ''}`} to={genLink('/my')}><UserCircleOutline className={css.IconUser} />{t('user-center.title')}</Link>
        </div>
      </div>
      <Notice />
      {process.env.REACT_APP_IDN_ENV === 'hw' && <QuestionList />}
      <CenterSelf />
      <SelfService />

      {
        process.env.REACT_APP_IDN_ENV !== 'hw' && <div className={css.PageFt}>
          <Card title={t('question.title')} onClick={toQuestionListPage}>
            <div className={'flex-between'}><span>{t('question.list-1')}</span><RightOutline /></div>
          </Card>
        </div>
      }

    </div>
  )
}


export default withTranslation()(Home)